import React from "react";
import Login from "./pages/Login";

function App() {
  return <Login />;
}

export default App;